import vueVimeoPlayer from 'vue-vimeo-player'
import { createApp } from 'vue'
import App from './App.vue'

createApp(App).use(vueVimeoPlayer).mount('#app')
